// extracted by mini-css-extract-plugin
export default {"modalBody":"delete-vehicle-modal_modalBody__pd9xr","name":"delete-vehicle-modal_name__g0twZ","button":"delete-vehicle-modal_button__FRKyF"};